import { rgba } from "polished";
import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { IElementType } from "core-integration/src/store/element-types/types";
import { PitchElementWrap } from "../Pitch";
import PlaceholderIcon from "../PlaceholderIcon";

const StyledPlaceholder = styled.button`
  position: relative;
  display: block;
  width: 6.4rem;
  height: 7.4rem;
  margin: auto;
  padding: ${({ theme }) => theme.space[1]} 0 0 0;
  border: ${({ theme }) => theme.borders[4]};
  border-radius: ${({ theme }) => theme.radii[1]};
  background: ${({ theme }) => theme.colors.green06};
  backdrop-filter: blur(2px);
  box-shadow: 0 0 11px 0 ${({ theme }) => theme.colors.greyDark04};
  text-align: center;
  line-height: 1;
  cursor: pointer;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: 11rem;
    height: 12.4rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 12rem;
    height: 14.8rem;
    padding: 0;
  }
`;

const Title = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 1.25rem 0;
  border-bottom-right-radius: ${({ theme }) => theme.radii[1]};
  border-bottom-left-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${rgba("#035f1d", 1)};
  color: white;
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding: 1.7rem 0;
    font-size: ${({ theme }) => theme.fontSizes[0]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding: 1.8rem 0;
    font-size: ${({ theme }) => theme.fontSizes[0]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding: 1.75rem 0;
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }
`;

const Abbr = styled.abbr`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    text-decoration: none;
    text-transform: lowercase;
    &::after {
      content: attr(title);
    }
  }
`;

const Span = styled.span`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: none;
  }
`;

interface IProps {
  elementType: IElementType | null;
  onClick: () => void;
}

const PitchPlaceholder: React.FC<IProps> = ({ elementType, onClick }) => {
  const { t } = useTranslation();
  if (!elementType) {
    return null;
  }
  return (
    <PitchElementWrap>
      <StyledPlaceholder onClick={onClick}>
        <PlaceholderIcon />
        <Title data-testid="title">
          {t("add", "Add")}{" "}
          <Abbr title={elementType.singular_name}>
            <Span>{elementType.singular_name_short}</Span>
          </Abbr>
        </Title>
      </StyledPlaceholder>
    </PitchElementWrap>
  );
};

export default PitchPlaceholder;
